import { bemBuilder } from "@chatfood/core-utils";

const className = "error-view";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
